<template>
  <div :class="['c-picker-create-board', { active: active === true }]">
    <form @submit.prevent="onSubmit" action="">
      <svg
        @click="close"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9.70711 8.29289C9.31658 7.90237 8.68342 7.90237 8.29289 8.29289C7.90237 8.68342 7.90237 9.31658 8.29289 9.70711L10.5858 12L8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071C8.68342 16.0976 9.31658 16.0976 9.70711 15.7071L12 13.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4142 12L15.7071 9.70711C16.0976 9.31658 16.0976 8.68342 15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289L12 10.5858L9.70711 8.29289Z"
          fill="currentColor"
        />
      </svg>

      <input type="text" v-model="name" placeholder="Enter board name" />
      <span>
        <button type="submit">
          <svg
            v-if="!processing"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM15.774 10.1333C16.1237 9.70582 16.0607 9.0758 15.6332 8.72607C15.2058 8.37635 14.5758 8.43935 14.226 8.86679L10.4258 13.5116L9.20711 12.2929C8.81658 11.9024 8.18342 11.9024 7.79289 12.2929C7.40237 12.6834 7.40237 13.3166 7.79289 13.7071L9.79289 15.7071C9.99267 15.9069 10.2676 16.0129 10.5498 15.9988C10.832 15.9847 11.095 15.8519 11.274 15.6333L15.774 10.1333Z"
              fill="currentColor"
            />
          </svg>
          <span v-else class="c-spinner"> </span>
        </button>
      </span>
    </form>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      name: '',
      processing: false,
    };
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    baseUrl: {},
    folder: {},
    mode: {
      default: 'extension',
    },
  },

  computed: {},

  methods: {
    close: function () {
      this.name = '';
      this.$emit('closeCreateBoard');
    },
    onSubmit: async function () {
      if (this.processing) {
        return;
      }
      this.processing = true;

      let name = this.name;

      if (!name) {
        this.processing = false;
        return;
      }

      if (name.length < 3) {
        this.processing = false;
        return;
      }

      const folder = this.folder;

      const board = await this.$store.dispatch('boards/add', {
        name: name,
        folderId: folder.id,
      });

      this.processing = false;

      if (board) {
        this.$emit('createBoard', board);
      }
    },
  },
};
</script>

<style lang="scss">
.c-picker-create-board {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  transition: all 180ms cubic-bezier(0.215, 0.61, 0.355, 1);
  user-select: none;
  opacity: 0;
  pointer-events: none;

  &.active {
    opacity: 1;
    user-select: all;
    pointer-events: initial;
  }

  form {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    display: grid;
    padding: 4px;
    grid-template-columns: 1fr 36px;

    input {
      user-select: initial;
      width: calc(100% - 32px);
    }

    > svg {
      position: absolute;
      top: 4.5px;
      right: 44px;
      color: #e45129;
      cursor: pointer;
    }

    > span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      border-left: #dfdfdf solid 1px;

      > button {
        padding: 0;
        position: relative;
        -webkit-appearance: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border: none;
        color: #665bdb;
        background-color: #fff;
        width: 24px;
        height: 24px;
        border-radius: 99px;
      }

      .c-spinner {
        width: 15px;
        height: 15px;
        margin-left: 0;
        border-bottom-color: #665bdb;
      }
    }
  }
}
</style>
